import { getCurrentUserToken } from "@/lib/auth";
import { useQuery } from "@tanstack/react-query";
import { getUserInvoices } from "../handlers/getUserInvoices";

export const USER_INVOICES_QUERY_KEY = "user-invoices";

export const useUserInvoicesQuery = (enabled: boolean = false) => {
  return useQuery({
    queryKey: [USER_INVOICES_QUERY_KEY],
    queryFn: async () => {
      const token = await getCurrentUserToken();
      if (!token) {
        throw new Error("No authentication token");
      }

      const response = await getUserInvoices({ token });
      return response.data || [];
    },
    enabled, // Only fetch when enabled is true
    staleTime: 10 * 60 * 1000, // Data stays fresh for 10 minutes
    cacheTime: 10 * 60 * 1000, // Keep in cache for 10 minutes (v4 syntax)
    retry: 2,
    refetchOnMount: false, // Don't refetch on component remount
    refetchOnWindowFocus: false, // Don't refetch on window focus
  });
};
